import { Grid } from '@mui/material';
import { memo } from 'react';
import DataDeclaration from './data-declaration';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import {
  DataDeclarationVM,
  FormDeclarationIcaroVM,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { useEventCallback } from '@mui/material';
import SubjectIcaro from './subject-icaro';
import ActionsForm from './actions-form';

interface IcaroAccordionsProps {
  goBack: () => void;
  onClickInsertEvent: () => void;
  onClickCancel: () => void;
  isRejectionState?: boolean;
}

const IcaroAccordionsComponent = ({
  goBack,
  onClickInsertEvent,
  onClickCancel,
  isRejectionState,
}: IcaroAccordionsProps): React.ReactElement => {
  const formContext = useFormikContext<FormDeclarationIcaroVM>();

  const onChangeDataDeclaration = useEventCallback(
    (key: keyof DataDeclarationVM, value: DataDeclarationVM[keyof DataDeclarationVM]) => {
      formContext.setFieldValue('dataDeclaration', {
        ...(formContext.values.dataDeclaration || {}),
        [key]: value,
      });
    }
  );

  const onChangeFather = useEventCallback(
    (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => {
      formContext.setFieldValue('father', {
        ...(formContext.values.father || {}),
        [key]: value,
      });
    }
  );

  const onChangeMother = useEventCallback(
    (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => {
      formContext.setFieldValue('mother', {
        ...(formContext.values.mother || {}),
        [key]: value,
      });
    }
  );

  const onChangeDeclarant = useEventCallback(
    (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => {
      formContext.setFieldValue('declarant', {
        ...(formContext.values.declarant || {}),
        [key]: value,
      });
    }
  );

  const onChangeBorn = useEventCallback(
    (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => {
      formContext.setFieldValue('born', {
        ...(formContext.values.born || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataDeclaration
          disabled
          values={formContext.values.dataDeclaration || {}}
          errors={(formContext.errors.dataDeclaration || {}) as FormikErrors<DataDeclarationVM>}
          touched={(formContext.touched.dataDeclaration || {}) as FormikTouched<DataDeclarationVM>}
          onChange={onChangeDataDeclaration}
          isRejectionState={isRejectionState}
        />
        <SubjectIcaro
          title="Padre"
          disabled
          values={formContext.values.father || {}}
          errors={(formContext.errors.father || {}) as FormikErrors<SubjectIcaroVM>}
          touched={(formContext.touched.father || {}) as FormikTouched<SubjectIcaroVM>}
          onChange={onChangeFather}
        />
        <SubjectIcaro
          title="Madre"
          disabled
          values={formContext.values.mother || {}}
          errors={(formContext.errors.mother || {}) as FormikErrors<SubjectIcaroVM>}
          touched={(formContext.touched.mother || {}) as FormikTouched<SubjectIcaroVM>}
          onChange={onChangeMother}
        />
        <SubjectIcaro
          title="Dichiarante"
          disabled
          values={formContext.values.declarant || {}}
          errors={(formContext.errors.declarant || {}) as FormikErrors<SubjectIcaroVM>}
          touched={(formContext.touched.declarant || {}) as FormikTouched<SubjectIcaroVM>}
          onChange={onChangeDeclarant}
          isDeclarant
        />
        <SubjectIcaro
          title="Nato"
          disabled
          values={formContext.values.born || {}}
          errors={(formContext.errors.born || {}) as FormikErrors<SubjectIcaroVM>}
          touched={(formContext.touched.born || {}) as FormikTouched<SubjectIcaroVM>}
          onChange={onChangeBorn}
          isBorn
        />
      </Grid>
      <ActionsForm
        state={formContext.values.dataDeclaration?.state}
        numberTwins={formContext.values.born?.numberTwins}
        goBack={goBack}
        onClickInsertEvent={onClickInsertEvent}
        onClickCancel={onClickCancel}
        isRejectionState={isRejectionState}
      />
    </Grid>
  );
};

IcaroAccordionsComponent.displayName = 'Icaro Accordions Component';

const IcaroAccordions = memo(IcaroAccordionsComponent);

export default IcaroAccordions;
